<template>
  <div class="index-ranking full-height">
    <div class="bg-white p-y-15 p-x-24 border-radius-12 full-height">
      <div class="font-14 flex-s-0 m-b-24" >销售排行榜</div>
      <a-table
        v-if="device !== 'mobile'"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        size="small"
        :bordered="false"
        :scroll="{ x: '100%' }"
        :rowKey="record=> record.objectId"
        @change="handleTableChange"
        :pagination="{
          position: 'bottom',
          current: current,
          pageSize: 6,
          total: finalData.length,
          hideOnSinglePage: true,
        }"
      >
        <template slot="name" slot-scope="text, record">{{ record.name }}</template>
        <template slot="salesVolume" slot-scope="salesVolume">
          <span class="font-bold">{{ salesVolume }}</span>
        </template>
      </a-table>
      <div v-else>
        <a-descriptions bordered v-for="(item,index) in phoneData" :key="index" style="margin-bottom: 20px">
          <a-descriptions-item
            v-for="( itm, i) in columns" :key="`item${i}`"
            :label="itm.title"
          >
            <div v-if="itm.dataIndex === 'name'">
              <span>{{ item[itm.dataIndex] }}</span>
            </div>
            <div v-else-if="itm.dataIndex === 'salesVolume'">
              <span class="font-bold">{{ item[itm.dataIndex] }}</span>
            </div>
            <div v-else>{{ item[itm.dataIndex] }}</div>
          </a-descriptions-item>
        </a-descriptions>
        <a-pagination simple :current="phoneCurrent" :pageSize="6" :total="finalData.length" @change="change" hideOnSinglePage/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: true,
      columns: [
        {
          title: '排名',
          dataIndex: 'index',
          key: 'index',
          scopedSlots: { customRender: 'index' },
          width: 50
        },
        {
          title: '门店',
          dataIndex: 'fullName',
          key: 'fullName',
          scopedSlots: { customRender: 'fullName' },
          width: 200
        },
        {
          title: '代理商',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
          width: 100
        },
        {
          title: '销量',
          dataIndex: 'salesNum',
          key: 'salesNum',
          scopedSlots: { customRender: 'salesNum' },
          width: 50
        },
        {
          title: '销售额',
          dataIndex: 'salesVolume',
          key: 'salesVolume',
          scopedSlots: { customRender: 'salesVolume' },
          width: 70
        }
      ],
      data: [],
      current: 1,
      total: 0,
      phoneData: [],
      phoneCurrent: 1,
      deleteStore: [],
      staffStore: [],
      finalData: [] // 统计最终数据
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getDeleteStore()
      let where = {}
      if (this.user.adminRole === 'staff') {
        if (this.user.level === '1') {
          where.warZone = this.user.department
        }
        if (this.user.level === '2') {
          where.regional = this.user.department
        }
        if (this.user.level === '3') {
          where.agency = this.user.department
          where.agent = this.user.objectId
        }
        if (this.user.level === '4') {
          where.salesmancy = this.user.department
          where.salesman = this.user.objectId
        }
        await this.getStaffStore(where)
      }
      // 统计订单
      let { data: res } = await this.$tkParse.get(`/aggregate/order`, {
        params: {
          group: {
            objectId: '$store',
            orderNum: {
              $sum: 1
            },
            orderAmount: {
              $sum: '$orderAmount'
            }
          },
          match: {
            status: '2',
            ...where
          } // 查询条件
        }
      })
      // 排除 删除门店 后数据
      let arr = res.results.filter(e => !this.deleteStore.includes(e.objectId))
      if (this.user.adminRole === 'staff') {
        arr = arr.filter(e => this.staffStore.includes(e.objectId))
        console.log(arr, '筛选后')
      }
      arr.sort((a, b) => {
        if (b.orderNum === a.orderNum) {
          return b.orderAmount - a.orderAmount
        }
        return b.orderNum - a.orderNum
      })
      this.finalData = arr
      this.getData(this.current)
    },
    // 获取已删除的门店
    async getDeleteStore () {
      let count = 100
      let page = 0
      while (true) {
        let { data: deleteStore } = await this.$tkParse.get(`/classes/store`, {
          params: {
            limit: count,
            skip: count * page,
            keys: 'objectId',
            where: {
              isDelete: true
            }
          }
        })
        this.deleteStore = [...this.deleteStore, ...deleteStore.results.map(e => e.objectId)]
        page++
        if (deleteStore.results.length < 100) break
      }
    },
    // 获取员工身份门店
    async getStaffStore (where) {
      let count = 100
      let page = 0
      while (true) {
        let { data: store } = await this.$tkParse.get(`/classes/store`, {
          params: {
            limit: count,
            skip: count * page,
            keys: 'objectId',
            where: {
              isDelete: false,
              ...where
            }
          }
        })
        this.staffStore = [...this.staffStore, ...store.results.map(e => e.objectId)]
        page++
        if (store.results.length < 100) break
      }
      console.log(this.staffStore, 'this.statsdhsjdjsa')
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(pagination, filters, sorter)
      this.current = pagination.current
      this.getData(this.current)
    },
    change (page, pageSize) {
      this.phoneCurrent = page
      // this.phoneData = this.data.slice((page - 1) * 6, Math.min(page * 6, this.data.length))
      this.getData(this.phoneCurrent)
    },
    async getData (current) {
      this.loading = true
      let arr = this.finalData.slice((current - 1) * 6, Math.min(current * 6, this.finalData.length))
      let idArr = arr.map(e => e.objectId)
      let { data: res } = await this.$tkParse.get(`/classes/store`, {
        params: {
          include: 'agent',
          where: {
            objectId: {
              $in: idArr
            }
          }
        }
      })
      let tableData = []
      arr.forEach((e, i) => {
        let item = res.results.find(itm => itm.objectId === e.objectId)
        tableData.push({
          index: i + 1,
          name: item.agent.fullName,
          salesVolume: e.orderAmount,
          salesNum: e.orderNum,
          fullName: item.fullName
        })
      })
      this.data = tableData
      this.phoneData = tableData
      console.log(arr)
      this.loading = false
    }
  }
}
</script>
<style scoped lang="scss">

</style>
